import { observer } from 'mobx-react-lite';
import loc from 'owa-localize';
import { OptionSubCategory } from 'owa-options-core';
import * as React from 'react';
import { OptionsCloseButton } from './OptionsCloseButton';
import { IconButton } from 'office-ui-fabric-react/lib/Button';
import { ControlIcons } from 'owa-control-icons';

const styles = require('./OptionsFull.scss');

export interface SettingsFormHeaderProps {
    selectedSubCategory: OptionSubCategory;
    onOpenFlyout?(): void;
}

export default observer(function SettingsFormHeader({
    selectedSubCategory,
    onOpenFlyout,
}: SettingsFormHeaderProps) {
    return (
        <div className={styles.settingsHeader}>
            <div className={styles.settingsTitle} role="heading" aria-level={3}>
                {onOpenFlyout && (
                    <IconButton
                        iconProps={{
                            iconName: ControlIcons.Back,
                        }}
                        className={styles.iconButton}
                        onClick={onOpenFlyout}
                    />
                )}
                {loc(selectedSubCategory.titleStringKey)}
            </div>
            <div className={styles.settingsHeaderButtons}>
                <OptionsCloseButton selectedSubCategoryKey={selectedSubCategory.key} />
            </div>
        </div>
    );
});
